import React from 'react';
import { connect } from 'react-redux';

import '../css/cart-quantity-indicator.less';

class CartQuantityIndicator extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			recentlyAdded: 1
		}
	}

	componentDidUpdate(prevProps) {
		let newCartQty = this.props.cartInfo.tQty;
		let oldCartQty = prevProps.cartInfo.tQty;
		
		if (newCartQty > oldCartQty) {
			this.setState({ recentlyAdded: this.state.recentlyAdded + (newCartQty - oldCartQty)})
		}
	}

	render() {
		const { recentlyAdded } = this.state;
		const { device } = this.props;
		return(
			<div className='xsell-indicator-wrapper'>
				{device !== 'mobile' ? 
					`Added ${recentlyAdded} ${recentlyAdded > 1 ? 'items' : 'item'} to your basket` :
					`${recentlyAdded} ${recentlyAdded > 1 ? 'items' : 'item'} added to your basket`}
			</div>
		)
	}
}

const mapStateToProps = (state) => ({ cartInfo: state.cartInfo });

export default connect(mapStateToProps, null)(CartQuantityIndicator);
